import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AlterarSenhaComponent } from './pages/alterar-senha/alterar-senha.component';
import { EscritoriosComponent } from './pages/cadastros/escritorios/escritorios.component';
import { ColaboradoresComponent } from './pages/cadastros/colaboradores/colaboradores.component';
import { LoginComponent } from './pages/login/login.component';
import { RecuperarSenhaComponent } from './pages/recuperar-senha/recuperar-senha.component';
import { ExtracoesComponent } from './pages/extracoes/extracoes.component';
import { AuthGuard } from './auth.guard';
import { DctfComponent } from './pages/exportacoes/dctf/dctf.component';
import { IcmsComponent } from './pages/exportacoes/icms/icms.component';
import { EcfComponent } from './pages/exportacoes/ecf/ecf.component';
import { EcdComponent } from './pages/exportacoes/ecd/ecd.component';
import { EfdComponent } from './pages/exportacoes/efd/efd.component';
import { PagamentoIndevidoMaiorComponent } from './pages/dcomp/pagamento-indevido-maior/pagamento-indevido-maior.component';
import { CfeComponent } from './pages/importacoes/cfe/cfe.component';
import { CteComponent } from './pages/importacoes/cte/cte.component';
import { IdctfComponent } from './pages/importacoes/idctf/idctf.component';
import { IecdComponent } from './pages/importacoes/iecd/iecd.component';
import { IecfComponent } from './pages/importacoes/iecf/iecf.component';
import { IefdComponent } from './pages/importacoes/iefd/iefd.component';
import { IicmsComponent } from './pages/importacoes/iicms/iicms.component';
import { NfeComponent } from './pages/importacoes/nfe/nfe.component';
import { RessarcimentoComponent } from './pages/dcomp/ressarcimento/ressarcimento.component';
import { Home2Component } from './pages/home2/home2.component';
import { TagsComponent } from './pages/cadastros/tags/tags.component';
import { ConfiguracoesComponent } from './pages/configuracoes/configuracoes.component';
import { AnalisesComponent } from './pages/analises/analise/analises.component';
import { ConhecimentoComponent } from './pages/conhecimento/conhecimento.component';
import { DownloadsComponent } from './pages/downloads/downloads.component';
import { DashboardDevComponent } from './pages/dashboard-dev/dashboard-dev.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'recuperar-senha',
    component: RecuperarSenhaComponent,
  },
  {
    path: 'escritorios',
    component: EscritoriosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'alterar-senha',
    component: AlterarSenhaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'colaboradores',
    component: ColaboradoresComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'extracoes',
    component: ExtracoesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'analises',
    component: AnalisesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'retificacao-dctf',
    component: DctfComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'retificacao-efd',
    component: EfdComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'retificacao-ecd',
    component: EcdComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'retificacao-ecf',
    component: EcfComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'retificacao-icms',
    component: IcmsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'dcomp-indevido-ou-a-maior',
    component: PagamentoIndevidoMaiorComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'importacao-cfe',
    component: CfeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'importacao-cte',
    component: CteComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'importacao-dctf',
    component: IdctfComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'importacao-ecd',
    component: IecdComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'importacao-ecf',
    component: IecfComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'importacao-efd',
    component: IefdComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'importacao-icms',
    component: IicmsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'importacao-nfe',
    component: NfeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'dcomp-ressarcimento',
    component: RessarcimentoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard/:id',
    component: DashboardDevComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'home',
    component: Home2Component,
    canActivate: [AuthGuard],
  },
  {
    path: 'tags',
    component: TagsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'configuracoes',
    component: ConfiguracoesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'conhecimento',
    component: ConhecimentoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'downloads',
    component: DownloadsComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
